import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class DeductibleIndividualZero extends Base {
  static isVisible = ({ deductibleAmountIndividualInNetwork }: any) =>
    !isEmpty(deductibleAmountIndividualInNetwork) &&
    parseInt(deductibleAmountIndividualInNetwork, 10) === 0;

  icon = '/images/insurance_tutorial/06_individual_deductible.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>No deductible, no problem</H2>

            <P>
              Since your plan doesn't have a deductible, you may pay a higher monthly premium. But
              that also means that your insurance company will always pay for part of your
              healthcare services. Cha-ching.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default DeductibleIndividualZero;
